import React from "react";
import "./Carousel.css";
var Carousel = require("react-responsive-carousel").Carousel;

const baseChildren = (orders) =>
  orders.map((order, index) => (
    <div key={index} className="carusel_main">
      <div>
        <p>{order.years}</p>{" "}
      </div>
      <div>
        <p>{order.id_rate}</p>
      </div>
      <div>
        <p>{order.pribil}</p>
      </div>
      <div>
        <p>{order.spec}</p>
      </div>
      <div>
        <p>{order.groups}</p>
      </div>
      <div>
        <p>{order.ubil}</p>
      </div>
    </div>
  ));

const getConfigurableProps = () => ({
  showArrows: true,
  showStatus: false,
  showIndicators: true,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  autoPlay: false,
  stopOnHover: true,
  swipeable: true,
  dynamicHeight: false,
  emulateTouch: true,
  thumbWidth: 0,
  // selectedItem: 1,
  interval: 50000,
  transitionTime: 400,
  swipeScrollTolerance: 5,
});
const arrowStyles = {
  position: "absolute",
  zIndex: 2,
  top: "12.5px",
  width: 20,
  height: 20,
  cursor: "pointer",
};

export class BaseCarousel extends React.Component {
  render() {
    return (
      <Carousel
        {...getConfigurableProps()}
        selectedItem={this.props.order.length - 1}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <div
              className="Btn_left"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 5 }}
            >
              <div
                className="prev"
                style={{ backgroundImage: "url(/lms/public/img/Left.png)" }}
              ></div>
            </div>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <div
              className="Btn_right"
              type="button"
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 5 }}
            >
              <div
                className="next"
                style={{ backgroundImage: "url(/lms/public/img/Right.png)" }}
              ></div>
            </div>
          )
        }
      >
        {baseChildren(this.props.order)}
      </Carousel>
    );
  }
}
